import React from "react";
import Woodstove from "../images/residentialheader.jpg"

const Residential = () => {
    return (
        <div>
            <h1>Residential</h1>
            <img src={Woodstove} class="img-fluid mb-3" />
            <div class="text">
                <p>There is nothing more cozy and relaxing than a crackling fire burning in a wood stove on a cold winter night. At Brookline Firewood we provide top quality firewood for your home and family including delivery to your doorstep
                    within the Brookline area. Do you have any special requirements? No problem! We will accomodate different lengths, split sizes or smaller quantities, such as half cords.<br></br>Our firewood comes in seasoned or kiln-dried qualities ensuring the maximal heat output the day of delivery. In residential applications, sometimes there is no other way than storing firewood indoors.
                    Kiln-dried firewood was exposed to high temperatures over multiple days, making it bug-free and an excellent choice for storage indoors.

                </p>
            </div>

        </div >
    )
};
export default Residential;